import { render, staticRenderFns } from "./AudioCard.vue?vue&type=template&id=05171c46&scoped=true&"
import script from "./AudioCard.vue?vue&type=script&lang=js&"
export * from "./AudioCard.vue?vue&type=script&lang=js&"
import style0 from "./AudioCard.vue?vue&type=style&index=0&id=05171c46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05171c46",
  null
  
)

export default component.exports